import { callApi } from "../callApi"

export enum ROLES_TITLE {
  role_admin = "admin",
  role_manager = "manager",
  role_user = "user",
}

export type USER_ROLE = {
  id: number
  email: string
  firstname: string
  lastname: string
  role?: ROLES_TITLE
}

export type PARTNER_USERS = {
  name: ROLES_TITLE
  resource_type?: string
  resource_uuid?: string
  users: USER_ROLE[]
}

export const getPartnerUuidRoles = async (partnerUuid: string) => {
  return callApi<null, PARTNER_USERS[]>({
    method: "GET",
    path: `/partner/${partnerUuid}/roles`,
  })
}
